import base from "../baseurl";
import token from "../getTk";

const showAll = async (type) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const showAllPositions = await api
    .post("candidate-positions/showall", {
      json: {
        isSingular: type,
      },
    })
    .json();
  console.log("tipo", type);
  return showAllPositions;
};

export default showAll;
